module.exports = __webpack_public_path__ + "img/position_list1.e94f26ab.png";